// ──────────────────────────────────────────────────────────────
// To remove bautagebuch from the platform:
// 1. Delete this folder: frontend/swarm-app/src/app/components/bautagebuch/
// 2. Remove BautagebuchModule import from app.module.ts
// 3. Remove /bautagebuch route from app-routing.module.ts
// 4. Grep for "BAUTAGEBUCH" to find remaining touchpoints (~5 locations)
// 5. Delete bautagebuch-service/ folder
// 6. Remove gateway route in gateway/src/main/resources/application.yml
// 7. Remove bautagebuch-service from docker-compose.yml
// 8. Remove ci-bautagebuch-service.yml from .github/workflows/
// ──────────────────────────────────────────────────────────────
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { CustomMaterialModule } from 'src/app/customModules/app-material-module';
import { SharedModule } from 'src/app/construct-x/shared/shared.module';
import { DataspaceReportStatusBadgeComponent } from './components/dataspace-report-status-badge/dataspace-report-status-badge.component';
import { DataspaceReportWorkspaceLayoutComponent } from './components/dataspace-report-workspace-layout/dataspace-report-workspace-layout.component';
import { ActivityTimelineComponent } from './components/activity-timeline/activity-timeline.component';
import { EnforcementStateBannerComponent } from './components/enforcement-state-banner/enforcement-state-banner.component';
import { TagesberichtNuLegacyFormBridgeComponent } from './components/tagesbericht-nu-legacy-form-bridge/tagesbericht-nu-legacy-form-bridge.component';
import { BautagebuchGuLegacyFormBridgeComponent } from './components/bautagebuch-gu-legacy-form-bridge/bautagebuch-gu-legacy-form-bridge.component';
import { BautagebuchDialogShellComponent } from './dialog-shell/bautagebuch-dialog-shell.component';
import { DataspaceGuInboxViewComponent } from './workspaces/dataspace-gu-inbox-view/dataspace-gu-inbox-view.component';
import { DataspaceNuReportsViewComponent } from './workspaces/dataspace-nu-reports-view/dataspace-nu-reports-view.component';
import { DataspaceReportsWorkspaceComponent } from './workspaces/dataspace-reports-workspace/dataspace-reports-workspace.component';
import { BauherrDashboardWorkspaceComponent } from './workspaces/bauherr-dashboard-workspace/bauherr-dashboard-workspace.component';
import { BautagebuchGuWorkspaceComponent } from './workspaces/bautagebuch-gu-workspace/bautagebuch-gu-workspace.component';
import { TagesberichtNuWorkspaceComponent } from './workspaces/tagesbericht-nu-workspace/tagesbericht-nu-workspace.component';
import { BautagebuchLegacyFormComponent } from './components/bautagebuch-legacy-form/bautagebuch-legacy-form.component';
import { ConnectorControlPlaneComponent } from './workspaces/connector-control-plane/connector-control-plane.component';
import { AssetRuleBuilderComponent } from './workspaces/connector-control-plane/components/asset-rule-builder/asset-rule-builder.component';
import { PolicyEditorComponent } from './workspaces/connector-control-plane/components/policy-editor/policy-editor.component';
import { GuDataAccessComponent } from './workspaces/dataspace-gu-inbox-view/components/gu-data-access/gu-data-access.component';
import { ComputeToDataPanelComponent } from './workspaces/dataspace-gu-inbox-view/components/compute-to-data-panel/compute-to-data-panel.component';
import { PurchaseDialogComponent } from './workspaces/dataspace-gu-inbox-view/components/purchase-dialog/purchase-dialog.component';

@NgModule({
  declarations: [
    BautagebuchDialogShellComponent,
    ActivityTimelineComponent,
    DataspaceReportStatusBadgeComponent,
    DataspaceReportWorkspaceLayoutComponent,
    EnforcementStateBannerComponent,
    BautagebuchLegacyFormComponent,
    TagesberichtNuLegacyFormBridgeComponent,
    BautagebuchGuLegacyFormBridgeComponent,
    DataspaceReportsWorkspaceComponent,
    DataspaceNuReportsViewComponent,
    DataspaceGuInboxViewComponent,
    ConnectorControlPlaneComponent,
    AssetRuleBuilderComponent,
    PolicyEditorComponent,
    GuDataAccessComponent,
    ComputeToDataPanelComponent,
    PurchaseDialogComponent,
    TagesberichtNuWorkspaceComponent,
    BautagebuchGuWorkspaceComponent,
    BauherrDashboardWorkspaceComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatChipsModule,
    MatTooltipModule,
    NgxChartsModule,
    NgxMatSelectSearchModule,
    SharedModule,
    CustomMaterialModule
  ],
  exports: [
    BautagebuchDialogShellComponent,
    DataspaceReportsWorkspaceComponent
  ]
})
export class BautagebuchModule {}
